export const strip = (arr: TemplateStringsArray, ...exprs: string[]) => {
  let str = '';
  for (let i = 0; i < arr.length; i++) {
    str += arr[i];
    if (i < exprs.length) {
      str += exprs[i];
    }
  }
  return str.trim().replace(/\n\s*/g, '');
};
